import {
    AggregatedByAndSubPlotValue,
    Dma,
    Localization,
    Region,
    SegmentSelect,
    SelectionAge,
    SelectionAlcoBeverages,
    SelectionBeautyCare,
    SelectionCategory,
    SelectionClothingFashion,
    SelectionConsumerElectro,
    SelectionEatingAndDrinking,
    SelectionFinancialProducts,
    SelectionGrocery,
    SelectionHeritage,
    SelectionIncome,
    SelectionInsurance,
    SelectionNonAlcogolic,
    SelectionPanelSexValue,
    SelectionSports,
    SelectionSubscription,
} from 'utils';
import {
    SidePanelSeparateStateUS,
    SidePanelSeparateStateUK,
} from '../DefaultSelection/sidePanelDefaultSelection';

export const sidePanelInitial: Record<any, any> = {
    [Localization.US]: {
        selectionData: SidePanelSeparateStateUS,
        selectionState: {
            dropDownAllCategories: SelectionCategory.GROCERY,
            dropDownAllSubcategories: {
                [SelectionCategory.ALCOGOLIC_BEVERAGES]: [
                    SelectionAlcoBeverages.WINE,
                    SelectionAlcoBeverages.BEER_AND_ALE,
                    SelectionAlcoBeverages.OTHER,
                ],
                [SelectionCategory.CONSUMER_ELECTRONICS]: [
                    SelectionConsumerElectro.E_READERS,
                    SelectionConsumerElectro.TELEVISIONS,
                    SelectionConsumerElectro.VIDEO_GAMES,
                    SelectionConsumerElectro.PERSONAL_CARE,
                    SelectionConsumerElectro.AUDIO_EQUIP,
                    SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS,
                    SelectionConsumerElectro.CELLPHONES,
                    SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES,
                ],
                [SelectionCategory.GROCERY]: [
                    SelectionGrocery.BAKED_GOODS,
                    SelectionGrocery.GENERAL_FOOD,
                    SelectionGrocery.CLEANING_AND_HYGIENE,
                    SelectionGrocery.PET_FOOD,
                    SelectionGrocery.SWEET_AND_SNACKS,
                ],
                [SelectionCategory.INSURANCE]: [
                    SelectionInsurance.HEALTH,
                    SelectionInsurance.VEHICLE,
                    SelectionInsurance.HOMEOWNER,
                    SelectionInsurance.LIFE_AND_PERSONAL,
                ],
                [SelectionCategory.NON_ALCOHOLIC_BEVERAGES]: [
                    SelectionNonAlcogolic.TEA,
                    SelectionNonAlcogolic.COLA,
                    SelectionNonAlcogolic.JUICE,
                    SelectionNonAlcogolic.OTHER,
                    SelectionNonAlcogolic.WATER,
                    SelectionNonAlcogolic.COFFEE,
                    SelectionNonAlcogolic.SPORTS_DRINKS,
                    SelectionNonAlcogolic.SODA,
                ],
                [SelectionCategory.SPORTS_AND_RECREATION]: [
                    SelectionSports.PARTICIPATION_FEES,
                    SelectionSports.EVENT_TICKETS,
                    SelectionSports.CLUB_MEMBERSHIPS,
                ],
                [SelectionCategory.SUBSCRIPTION]: [
                    SelectionSubscription.VIDEO_STREAMING,
                    SelectionSubscription.AUDIO_STREAMING,
                    SelectionSubscription.BOOKS_AND_EBOOKS,
                    SelectionSubscription.SHOPPING_MEMBERSHIP,
                ],
            },
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
            dropDownHeritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.MIXED_AND_OTHER,
            ],
            age: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            sex: [SelectionPanelSexValue.FEMALE, SelectionPanelSexValue.MALE],
            income: [
                SelectionIncome.GROUP_LESS_10k,
                SelectionIncome.GROUP_10k_TO_25k,
                SelectionIncome.GROUP_25k_TO_50k,
                SelectionIncome.GROUP_50k_TO_75k,
                SelectionIncome.GROUP_75k_TO_100k,
                SelectionIncome.GROUP_ABOVE_100k,
            ],
            hareSelection: {
                aggregatedBy: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
                subPlot: AggregatedByAndSubPlotValue.NONE,
            },
        },
        defaultSidePanelState: {
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
            dropDownHeritage: [
                SelectionHeritage.WHITE,
                SelectionHeritage.HISPANIC_ANY_RACE,
                SelectionHeritage.BLACK,
                SelectionHeritage.ASIAN,
                SelectionHeritage.MIXED_AND_OTHER,
            ],
            dropDownAllCategories: SelectionCategory.GROCERY,
            dropDownAllSubcategories: {
                [SelectionCategory.ALCOGOLIC_BEVERAGES]: [
                    SelectionAlcoBeverages.WINE,
                    SelectionAlcoBeverages.BEER_AND_ALE,
                    SelectionAlcoBeverages.OTHER,
                ],
                [SelectionCategory.CONSUMER_ELECTRONICS]: [
                    SelectionConsumerElectro.E_READERS,
                    SelectionConsumerElectro.TELEVISIONS,
                    SelectionConsumerElectro.VIDEO_GAMES,
                    SelectionConsumerElectro.PERSONAL_CARE,
                    SelectionConsumerElectro.AUDIO_EQUIP,
                    SelectionConsumerElectro.COMPUTERS_AND_LAPTOPS,
                    SelectionConsumerElectro.CELLPHONES,
                    SelectionConsumerElectro.SMALL_KITCHEN_APPLIANCES,
                ],
                [SelectionCategory.GROCERY]: [
                    SelectionGrocery.BAKED_GOODS,
                    SelectionGrocery.GENERAL_FOOD,
                    SelectionGrocery.CLEANING_AND_HYGIENE,
                    SelectionGrocery.PET_FOOD,
                    SelectionGrocery.SWEET_AND_SNACKS,
                ],
                [SelectionCategory.INSURANCE]: [
                    SelectionInsurance.HEALTH,
                    SelectionInsurance.VEHICLE,
                    SelectionInsurance.HOMEOWNER,
                    SelectionInsurance.LIFE_AND_PERSONAL,
                ],
                [SelectionCategory.NON_ALCOHOLIC_BEVERAGES]: [
                    SelectionNonAlcogolic.TEA,
                    SelectionNonAlcogolic.COLA,
                    SelectionNonAlcogolic.JUICE,
                    SelectionNonAlcogolic.OTHER,
                    SelectionNonAlcogolic.WATER,
                    SelectionNonAlcogolic.COFFEE,
                    SelectionNonAlcogolic.SPORTS_DRINKS,
                    SelectionNonAlcogolic.SODA,
                ],
                [SelectionCategory.SPORTS_AND_RECREATION]: [
                    SelectionSports.CLUB_MEMBERSHIPS,
                    SelectionSports.PARTICIPATION_FEES,
                    SelectionSports.EVENT_TICKETS,
                ],
                [SelectionCategory.SUBSCRIPTION]: [
                    SelectionSubscription.AUDIO_STREAMING,
                    SelectionSubscription.BOOKS_AND_EBOOKS,
                    SelectionSubscription.SHOPPING_MEMBERSHIP,
                    SelectionSubscription.VIDEO_STREAMING,
                ],
            },
            age: [
                SelectionAge.GROUP_18_24,
                SelectionAge.GROUP_25_34,
                SelectionAge.GROUP_35_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            sex: [SelectionPanelSexValue.FEMALE, SelectionPanelSexValue.MALE],
            income: [
                SelectionIncome.GROUP_LESS_10k,
                SelectionIncome.GROUP_10k_TO_25k,
                SelectionIncome.GROUP_25k_TO_50k,
                SelectionIncome.GROUP_50k_TO_75k,
                SelectionIncome.GROUP_75k_TO_100k,
                SelectionIncome.GROUP_ABOVE_100k,
            ],
        },
        tortoiseResponse: null,
        isTortoiseLoading: false,
        isTortoiseLoaded: false,
        error: false,
    },
    [Localization.UK]: {
        selectionData: SidePanelSeparateStateUK,
        selectionState: {
            dropDownAllCategories: SelectionCategory.GROCERIES,
            dropDownAllSubcategories: {
                [SelectionCategory.GROCERIES]: [
                    SelectionGrocery.ALCOHOL_AT_HOME_WITHOUT_BRACES,
                    SelectionGrocery.BABYCARE,
                    SelectionGrocery.CLEANING_PRODUCTS,
                    SelectionGrocery.FOOD,
                    SelectionGrocery.NEWSPAPERS_AND_MAGAZINES,
                    SelectionGrocery.PETCARE,
                ],
                [SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES]: [
                    SelectionFinancialProducts.SAVINGS,
                    SelectionFinancialProducts.INSURANCE,
                ],
                [SelectionCategory.EATING_AND_DRINKING_OUT]: [
                    SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES,
                    SelectionEatingAndDrinking.EATING_OUT,
                    SelectionEatingAndDrinking.TAKEAWAY,
                ],
                [SelectionCategory.CLOTHING_AND_FASHION]: [
                    SelectionClothingFashion.ADULT,
                    SelectionClothingFashion.CHILDREN,
                ],
                [SelectionCategory.BEAUTY_AND_PERSONAL_CARE]: [
                    SelectionBeautyCare.HAIR_AND_COSMETICS,
                    SelectionBeautyCare.TOILETRIES_AND_SOAP,
                    SelectionBeautyCare.TREATMENTS,
                ],
            },
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
            dropDownHeritage: [
                SelectionHeritage.EAST_AND_SOUTH_ASIAN,
                SelectionHeritage.BLACK,
                SelectionHeritage.SOUTH_ASIAN_PAKISTANI,
                SelectionHeritage.SOUTH_ASIAN_BANGLADESHI,
                SelectionHeritage.MIDDLE_EASTERN,
                SelectionHeritage.MIXED,
                SelectionHeritage.SOUTH_ASIAN_INDIAN,
                SelectionHeritage.WHITE,
            ],
            age: [
                SelectionAge.GROUP_LESS_16,
                SelectionAge.GROUP_16_24,
                SelectionAge.GROUP_25_29,
                SelectionAge.GROUP_30_39,
                SelectionAge.GROUP_40_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            sex: [SelectionPanelSexValue.FEMALE, SelectionPanelSexValue.MALE],
            income: [
                SelectionIncome.GROUP_LOW_INCOME,
                SelectionIncome.GROUP_MID_INCOME,
                SelectionIncome.GROUP_HIGH_INCOME,
            ],
            hareSelection: {
                aggregatedBy: AggregatedByAndSubPlotValue.SOCIO_ECONOMIC,
                subPlot: AggregatedByAndSubPlotValue.NONE,
            },
        },
        defaultSidePanelState: {
            geoMapSelection: {
                Segment: SegmentSelect.REGION,
                REGION: [Region.WEST, Region.MIDWEST, Region.SOUTH, Region.NORTHEAST],
                DMA: Dma.NEW_YORK_NY,
            },
            dropDownHeritage: [
                SelectionHeritage.EAST_AND_SOUTH_ASIAN,
                SelectionHeritage.BLACK,
                SelectionHeritage.SOUTH_ASIAN_PAKISTANI,
                SelectionHeritage.SOUTH_ASIAN_BANGLADESHI,
                SelectionHeritage.MIDDLE_EASTERN,
                SelectionHeritage.MIXED,
                SelectionHeritage.SOUTH_ASIAN_INDIAN,
                SelectionHeritage.WHITE,
            ],
            dropDownAllCategories: SelectionCategory.GROCERIES,
            dropDownAllSubcategories: {
                [SelectionCategory.GROCERIES]: [
                    SelectionGrocery.ALCOHOL_AT_HOME_WITHOUT_BRACES,
                    SelectionGrocery.BABYCARE,
                    SelectionGrocery.CLEANING_PRODUCTS,
                    SelectionGrocery.FOOD,
                    SelectionGrocery.NEWSPAPERS_AND_MAGAZINES,
                    SelectionGrocery.PETCARE,
                ],
                [SelectionCategory.FINANCIAL_PRODUCTS_AND_SERVICES]: [
                    SelectionFinancialProducts.SAVINGS,
                    SelectionFinancialProducts.INSURANCE,
                ],
                [SelectionCategory.EATING_AND_DRINKING_OUT]: [
                    SelectionEatingAndDrinking.DRINKING_OUT_ALCOHOL_WITHOUT_PARENTHESES,
                    SelectionEatingAndDrinking.EATING_OUT,
                    SelectionEatingAndDrinking.TAKEAWAY,
                ],
                [SelectionCategory.CLOTHING_AND_FASHION]: [
                    SelectionClothingFashion.ADULT,
                    SelectionClothingFashion.CHILDREN,
                ],
                [SelectionCategory.BEAUTY_AND_PERSONAL_CARE]: [
                    SelectionBeautyCare.HAIR_AND_COSMETICS,
                    SelectionBeautyCare.TOILETRIES_AND_SOAP,
                    SelectionBeautyCare.TREATMENTS,
                ],
            },
            age: [
                SelectionAge.GROUP_LESS_16,
                SelectionAge.GROUP_16_24,
                SelectionAge.GROUP_25_29,
                SelectionAge.GROUP_30_39,
                SelectionAge.GROUP_40_49,
                SelectionAge.GROUP_50_64,
                SelectionAge.GROUP_65_PLUS,
            ],
            sex: [SelectionPanelSexValue.FEMALE, SelectionPanelSexValue.MALE],
            income: [
                SelectionIncome.GROUP_LOW_INCOME,
                SelectionIncome.GROUP_MID_INCOME,
                SelectionIncome.GROUP_HIGH_INCOME,
            ],
        },
        tortoiseResponse: null,
        isTortoiseLoading: false,
        isTortoiseLoaded: false,
        error: false,
    },
};
